export default "__VITE_ASSET__BTOCq0hB__"